import * as React from 'react';

import { Button, Intent } from '@blueprintjs/core';
import type { ButtonProps } from '@blueprintjs/core';
import classNames from 'classnames';

export interface EvenButtonProps extends React.PropsWithChildren<ButtonProps> {
  'data-testid'?: string;
  role?: string;
  tertiary?: boolean;
}

export const EvenButton: React.FC<EvenButtonProps> = ({
  onClick = () => {},
  outlined,
  className: cln,
  loading,
  children,
  intent = Intent.PRIMARY,
  tertiary = false,
  disabled = false,
  'data-testid': dataTestId = 'EvenButton',
  ...props
}) => {
  const className = classNames(cln, tertiary && 'tertiary');

  return (
    <Button
      className={className}
      data-testid={`${dataTestId}_button`}
      disabled={disabled}
      intent={intent}
      loading={loading}
      outlined={outlined}
      onClick={onClick}
      {...props}
    >
      {children}
    </Button>
  );
};
